var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map((p=>{return+p==p?+p:p}))},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var ensureExistence = (scopeName, key) => {
	var scope = __webpack_require__.S[scopeName];
	if(!scope || !__webpack_require__.o(scope, key)) throw new Error("Shared module " + key + " doesn't exist in shared scope " + scopeName);
	return scope;
};
var findVersion = (scope, key) => {
	var versions = scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key) => {
	var versions = scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getSingleton = (scope, scopeName, key, requiredVersion) => {
	var version = findSingletonVersionKey(scope, key);
	return get(scope[key][version]);
};
var getSingletonVersion = (scope, scopeName, key, requiredVersion) => {
	var version = findSingletonVersionKey(scope, key);
	if (!satisfy(requiredVersion, version)) warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	return get(scope[key][version]);
};
var getStrictSingletonVersion = (scope, scopeName, key, requiredVersion) => {
	var version = findSingletonVersionKey(scope, key);
	if (!satisfy(requiredVersion, version)) throw new Error(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	return get(scope[key][version]);
};
var findValidVersion = (scope, key, requiredVersion) => {
	var versions = scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ") of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var getValidVersion = (scope, scopeName, key, requiredVersion) => {
	var entry = findValidVersion(scope, key, requiredVersion);
	if(entry) return get(entry);
	throw new Error(getInvalidVersionMessage(scope, scopeName, key, requiredVersion));
};
var warn = (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var warnInvalidVersion = (scope, scopeName, key, requiredVersion) => {
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion));
};
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var init = (fn) => (function(scopeName, a, b, c) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then) return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], a, b, c));
	return fn(scopeName, __webpack_require__.S[scopeName], a, b, c);
});

var load = /*#__PURE__*/ init((scopeName, scope, key) => {
	ensureExistence(scopeName, key);
	return get(findVersion(scope, key));
});
var loadFallback = /*#__PURE__*/ init((scopeName, scope, key, fallback) => {
	return scope && __webpack_require__.o(scope, key) ? get(findVersion(scope, key)) : fallback();
});
var loadVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return get(findValidVersion(scope, key, version) || warnInvalidVersion(scope, scopeName, key, version) || findVersion(scope, key));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key) => {
	ensureExistence(scopeName, key);
	return getSingleton(scope, scopeName, key);
});
var loadSingletonVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return getSingletonVersion(scope, scopeName, key, version);
});
var loadStrictVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return getValidVersion(scope, scopeName, key, version);
});
var loadStrictSingletonVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return getStrictSingletonVersion(scope, scopeName, key, version);
});
var loadVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return get(findValidVersion(scope, key, version) || warnInvalidVersion(scope, scopeName, key, version) || findVersion(scope, key));
});
var loadSingletonFallback = /*#__PURE__*/ init((scopeName, scope, key, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getSingleton(scope, scopeName, key);
});
var loadSingletonVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getSingletonVersion(scope, scopeName, key, version);
});
var loadStrictVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	var entry = scope && __webpack_require__.o(scope, key) && findValidVersion(scope, key, version);
	return entry ? get(entry) : fallback();
});
var loadStrictSingletonVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getStrictSingletonVersion(scope, scopeName, key, version);
});
var installedModules = {};
var moduleToHandlerMapping = {
	75166: () => (loadSingletonVersionCheckFallback("default", "react", [1,18,2,0], () => (() => (__webpack_require__(72791))))),
	3501: () => (loadSingletonVersionCheckFallback("default", "@reduxjs/toolkit", [1,1,9,7], () => (__webpack_require__.e(7881).then(() => (() => (__webpack_require__(91577))))))),
	39238: () => (loadSingletonVersionCheckFallback("default", "react-redux", [1,8,1,3], () => (Promise.all([__webpack_require__.e(8687), __webpack_require__.e(1051)]).then(() => (() => (__webpack_require__(78687))))))),
	49822: () => (loadSingletonVersionCheckFallback("default", "@cmctechnology/webinvest-store-frontend", [1,1,9,13], () => (Promise.all([__webpack_require__.e(545), __webpack_require__.e(4344), __webpack_require__.e(1005), __webpack_require__.e(6477)]).then(() => (() => (__webpack_require__(64344))))))),
	51005: () => (loadSingletonVersionCheckFallback("default", "@cmctechnology/webinvest-api-client-web-trading", [1,2,0,28], () => (__webpack_require__.e(7540).then(() => (() => (__webpack_require__(27540))))))),
	6477: () => (loadSingletonVersionCheckFallback("default", "@cmctechnology/webinvest-constants", [2,0,1,20], () => (__webpack_require__.e(1527).then(() => (() => (__webpack_require__(71527))))))),
	30198: () => (loadSingletonVersionCheckFallback("default", "dayjs", [1,1,11,10], () => (__webpack_require__.e(7892).then(() => (() => (__webpack_require__(97892))))))),
	31051: () => (loadSingletonVersionCheckFallback("default", "react-dom", [1,18,2,0], () => (__webpack_require__.e(4164).then(() => (() => (__webpack_require__(54164))))))),
	16557: () => (loadSingletonVersionCheckFallback("default", "stylis", [1,4,3,0], () => (__webpack_require__.e(2030).then(() => (() => (__webpack_require__(32030))))))),
	25209: () => (loadSingletonVersionCheckFallback("default", "@cmctechnology/webinvest-api-client-market-data-ws", [1,1,0,6], () => (__webpack_require__.e(8028).then(() => (() => (__webpack_require__(18028))))))),
	9226: () => (loadSingletonVersionCheckFallback("default", "@cmctechnology/webinvest-store-instruments", [1,1,2,25], () => (Promise.all([__webpack_require__.e(59), __webpack_require__.e(1005), __webpack_require__.e(6477), __webpack_require__.e(198)]).then(() => (() => (__webpack_require__(40059))))))),
	56400: () => (loadSingletonVersionCheckFallback("default", "@cmctechnology/webinvest-store-client", [1,1,4,74], () => (Promise.all([__webpack_require__.e(2467), __webpack_require__.e(3530), __webpack_require__.e(6477), __webpack_require__.e(198), __webpack_require__.e(7958)]).then(() => (() => (__webpack_require__(43530))))))),
	36505: () => (loadSingletonVersionCheckFallback("default", "styled-components", [1,6,1,1], () => (__webpack_require__.e(7406).then(() => (() => (__webpack_require__(97406))))))),
	57194: () => (loadSingletonVersionCheckFallback("default", "lodash.merge", [1,4,6,2], () => (__webpack_require__.e(7381).then(() => (() => (__webpack_require__(57381))))))),
	85167: () => (loadSingletonVersionCheckFallback("default", "@cmctechnology/webinvest-store-marketdata", [1,1,1,27], () => (Promise.all([__webpack_require__.e(2467), __webpack_require__.e(3690), __webpack_require__.e(1005), __webpack_require__.e(5209), __webpack_require__.e(6400), __webpack_require__.e(1291)]).then(() => (() => (__webpack_require__(3690))))))),
	704: () => (loadSingletonVersionCheckFallback("default", "@cmctechnology/webinvest-store-watchlists", [1,1,3,6], () => (__webpack_require__.e(305).then(() => (() => (__webpack_require__(40305))))))),
	881: () => (loadSingletonVersionCheckFallback("default", "@cmctechnology/webinvest-module", [1,1,2,7], () => (__webpack_require__.e(652).then(() => (() => (__webpack_require__(10652))))))),
	15578: () => (loadSingletonVersionCheckFallback("default", "@cmctechnology/webinvest-store-exchange", [1,1,7,2], () => (Promise.all([__webpack_require__.e(545), __webpack_require__.e(676)]).then(() => (() => (__webpack_require__(30676))))))),
	29141: () => (loadSingletonVersionCheckFallback("default", "react-device-detect", [1,2,2,3], () => (__webpack_require__.e(173).then(() => (() => (__webpack_require__(60173))))))),
	31395: () => (loadSingletonVersionCheckFallback("default", "@cmctechnology/webinvest-design-system", [2,0,83,16], () => (Promise.all([__webpack_require__.e(8444), __webpack_require__.e(3077), __webpack_require__.e(3957), __webpack_require__.e(5555), __webpack_require__.e(7299)]).then(() => (() => (__webpack_require__(73077))))))),
	32778: () => (loadSingletonVersionCheckFallback("default", "react-i18next", [1,13,3,1], () => (__webpack_require__.e(9230).then(() => (() => (__webpack_require__(39230))))))),
	42091: () => (loadSingletonVersionCheckFallback("default", "@cmctechnology/phoenix-stockbroking-web-design", [1,2,2,19], () => (Promise.all([__webpack_require__.e(8444), __webpack_require__.e(9898), __webpack_require__.e(3957), __webpack_require__.e(8646)]).then(() => (() => (__webpack_require__(79898))))))),
	58374: () => (loadSingletonVersionCheckFallback("default", "react-helmet-async", [1,1,3,0], () => (__webpack_require__.e(6907).then(() => (() => (__webpack_require__(6907))))))),
	59218: () => (loadSingletonVersionCheckFallback("default", "react-router-dom", [1,6,17,0], () => (__webpack_require__.e(6276).then(() => (() => (__webpack_require__(46276))))))),
	63542: () => (loadSingletonVersionCheckFallback("default", "@cmctechnology/webinvest-store-accounts", [1,2,1,13], () => (Promise.all([__webpack_require__.e(2467), __webpack_require__.e(300)]).then(() => (() => (__webpack_require__(10300))))))),
	64467: () => (loadSingletonVersionCheckFallback("default", "@cmctechnology/webinvest-store-charts", [1,1,6,15], () => (__webpack_require__.e(7949).then(() => (() => (__webpack_require__(17949))))))),
	65795: () => (loadSingletonVersionCheckFallback("default", "i18next-xhr-backend", [1,3,2,2], () => (__webpack_require__.e(8918).then(() => (() => (__webpack_require__(38918))))))),
	72123: () => (loadSingletonVersionCheckFallback("default", "i18next", [1,23,6,0], () => (__webpack_require__.e(8825).then(() => (() => (__webpack_require__(68825))))))),
	75115: () => (loadSingletonVersionCheckFallback("default", "@cmctechnology/webinvest-store-orders", [1,1,0,8], () => (Promise.all([__webpack_require__.e(2467), __webpack_require__.e(9144)]).then(() => (() => (__webpack_require__(59144))))))),
	94203: () => (loadSingletonVersionCheckFallback("default", "@cmctechnology/webinvest-store-subscriptions", [3,0,0,10], () => (__webpack_require__.e(1390).then(() => (() => (__webpack_require__(71390))))))),
	98066: () => (loadSingletonVersionCheckFallback("default", "usehooks-ts", [1,2,9,1], () => (__webpack_require__.e(7698).then(() => (() => (__webpack_require__(17698))))))),
	98389: () => (loadSingletonVersionCheckFallback("default", "@cmctechnology/webinvest-store-messages", [1,1,0,9], () => (__webpack_require__.e(2092).then(() => (() => (__webpack_require__(73995))))))),
	63957: () => (loadSingletonVersionCheckFallback("default", "lightweight-charts", [1,4,1,1], () => (__webpack_require__.e(63).then(() => (() => (__webpack_require__(30063))))))),
	58646: () => (loadSingletonVersionCheckFallback("default", "styled-components", [1,6,1,1], () => (__webpack_require__.e(321).then(() => (() => (__webpack_require__(90321))))))),
	75555: () => (loadSingletonVersionCheckFallback("default", "smooth-scroll-into-view-if-needed", [1,2,0,2], () => (__webpack_require__.e(8520).then(() => (() => (__webpack_require__(68520))))))),
	17958: () => (loadSingletonVersionCheckFallback("default", "@forgerock/javascript-sdk", [1,4,4,2], () => (__webpack_require__.e(4190).then(() => (() => (__webpack_require__(94190))))))),
	71291: () => (loadSingletonVersionCheckFallback("default", "@cmctechnology/webinvest-constants", [2,0,1,20], () => (__webpack_require__.e(7240).then(() => (() => (__webpack_require__(77240)))))))
};
// no consumes in initial chunks
var chunkMapping = {
	"198": [
		30198
	],
	"985": [
		36505,
		57194
	],
	"1005": [
		51005
	],
	"1051": [
		31051
	],
	"1291": [
		71291
	],
	"3501": [
		3501
	],
	"3957": [
		63957
	],
	"5166": [
		75166
	],
	"5167": [
		85167
	],
	"5209": [
		25209
	],
	"5555": [
		75555
	],
	"6400": [
		56400
	],
	"6477": [
		6477
	],
	"6557": [
		16557
	],
	"7798": [
		704,
		881,
		15578,
		29141,
		31395,
		32778,
		42091,
		58374,
		59218,
		63542,
		64467,
		65795,
		72123,
		75115,
		94203,
		98066,
		98389
	],
	"7958": [
		17958
	],
	"8646": [
		58646
	],
	"9226": [
		9226
	],
	"9238": [
		39238
	],
	"9822": [
		49822
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
		});
	}
}